<div class="app-container app-theme-white body-tabs-shadow">
    <div class="app-container">
        <div class="h-100">
            <div class="h-100 no-gutters row">
                <div class="d-none d-lg-block col-lg-5">
                    <div class="slider-light">
                        <div class="slick-slider h-100">
                            <div>
                                <div
                                    class="position-relative h-100 d-flex justify-content-center align-items-center bg-plum-plate">
                                    <div class="slide-img-bg"
                                        style="background-image: url('assets/images/Cust-login.png');"></div>
                                    <div class="slider-content">
                                        <h3>Welcome to Customer Portal</h3>
                                        <p>Designed exclusively for you—offering real-time project updates, dedicated service and support, and AI-driven assistance at your fingertips.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-7">
                    <div class="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9">
                        <div class="app-logo">
                        </div>
                        <h4 class="mb-0">
                            <span class="d-block">Recover Password</span>
                        </h4>
                        <div class="divider row"></div>
                        <div>
                            <form [formGroup]="loginForm">
                                <div class="form-row">
                                    <div class="col-md-6">
                                        <div class="position-relative form-group">
                                            <label for="emailId" class="">Email / User Name</label>
                                            <input name="emailId" id="emailId" formControlName="emailId"
                                                placeholder="Enter Email / User Name" type="text" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && loginForm.controls['emailId'].errors }">
                                            <!-- <div class="errorpopup alert alert-danger"
                                                *ngIf="submitted && loginForm.controls['customerContactDetails']['controls']['emailId'].errors">
                                                <div
                                                    *ngIf="loginForm.controls['customerContactDetails']['controls']['emailId'].errors.required">
                                                    Email is Required</div>
                                                <div
                                                    *ngIf="loginForm.controls['customerContactDetails']['controls']['emailId'].errors?.pattern">
                                                    Please enter valid email address</div>
                                            </div> -->
                                            <div class="errorpopup alert alert-danger"
                                                *ngIf="submitted && loginForm.get('subject').errors">
                                                <div *ngIf="loginForm.get('emailId').hasError('required')">Email is
                                                    Required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6" [hidden]="!otpDiv">
                                        <div class="position-relative form-group">
                                            <label for="otp" class="">OTP</label>
                                            <input name="otp" id="otp" formControlName="otp" placeholder="OTP here..."
                                                type="text" class="form-control">
                                        </div>
                                    </div>
                                </div>
                                <div class="divider row"></div>
                                <div class="d-flex align-items-center">
                                    <div class="ml-auto">
                                        <a href="javascript:void(0);" (click)="onSubmit()" class="btn-lg btn btn-link"
                                            [hidden]="!resendotpDiv">Re-Send OTP</a>
                                        <button class="btn btn-primary btn-lg" (click)="onSubmit()"
                                            [hidden]="!sendotpDiv">Send OTP</button>
                                        <button class="btn btn-primary btn-lg" (click)="onVerifyOTP()"
                                            [hidden]="!verifyotpDiv">Verify
                                            OTP</button>
                                        <button class="btn btn-danger btn-lg" (click)="onCancel()"
                                            style="margin-left: 10px;">
                                            Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>